module.exports = __webpack_public_path__ + "static/media/gestoria_verde.4060dc98.svg";